import { usePricingContentContext } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { QuestionsCta } from "@/components/wpl/pricing/src/questions-cta";
import { ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES } from "@/libraries/web-framework/src/localization/localization.constants";
import { useLocale } from "@/libraries/web-framework/src/localization/use-locale";
import { getLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";

export const RovoQuestionsCta = () => {
    const content = usePricingContentContext();
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;

    const locale = useLocale();
    const questionsCtaHref = `https://support.atlassian.com${getLocalizedHref({
        locale,
        href: "/subscriptions-and-billing/docs/managing-your-bill-for-rovo/",
        supportedLocales: ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES
    })}`;

    return (
        <QuestionsCta
            product={"Rovo"}
            ctaHref={questionsCtaContent?.url ?? questionsCtaHref}
            questionsHeader={questionsCtaContent?.title ?? undefined}
            priceAndLicensingLinkText={questionsCtaContent?.text ?? undefined}
            questionsBody={questionsCtaContent?.valueProposition ?? undefined}
            imageHref={questionsCtaContent?.asset?.url}
        />
    );
};
RovoQuestionsCta.displayName = "RovoQuestionsCtaSection";
